import bleachBackground from '../assets/images/bleachimage/bleach-image-background.jpg';
import bleachGameOverBackground from '../assets/images/bleachimage/bkeach-game-over-background.jpg';
import bleachIntroImage from '../assets/images/bleachimage/bleach-GAME START.png';

const animeConfig = {
  onePiece: {
    backgroundMusic: '/audio/game-song-background.mp3',
    incorrectSound: '/audio/incorrect-yasashi.mp3',
    gameOverSound: '/audio/game-over-show.mp3',
    correctAnswerSound: '/audio/correct-ans.mp3',
    introImage: '/GAME START.jpg',
    gameOverBackground: '/game-over-background.jpg',
    backgroundImage: require('../assets/images/seaonepiece.jpg'),
  },
  naruto: {
    backgroundMusic: '/audio/naruto-background-sound.mp3',
    incorrectSound: '/audio/Naruto/incorrect-naruto-answer.mp3',
    gameOverSound: '/audio/Naruto/naruto-game-over.mp3',
    correctAnswerSound: '/audio/Naruto/naruto-correct-answer.mp3',
    introImage: '/GAME START-naruto.jpg',
    gameOverBackground: '/naruto-game-over-image.jpg',
    backgroundImage: '/naruto-image-background.png',
  },
  bleach: {
    backgroundMusic: '/audio/Bleach/bleach-background-sound.mp3',
    incorrectSound: '/audio/Bleach/bleach-incorrect-answer.mp3',
    gameOverSound: '/audio/Bleach/Bleach-game-over.mp3',
    correctAnswerSound: '/audio/correct-ans.mp3',
    introImage: require('../assets/images/bleachimage/bleach-GAME START.png'),
    gameOverBackground: require('../assets/images/bleachimage/bkeach-game-over-background.jpg'),
    backgroundImage: require('../assets/images/bleachimage/bleach-image-background.jpg'),
  },
  onePunch: {
    backgroundMusic: '/audio/OnePunch/onepunch-background-sound.mp3',
    incorrectSound: '/audio/OnePunch/incorrect-onepunch.mp3',
    gameOverSound: '/audio/OnePunch/onepunch-game-over.mp3',
    correctAnswerSound: '/audio/correct-ans.mp3',
    introImage: require('../assets/images/OnePunchimage/GAME START-onepunch.png'),
    gameOverBackground: require('../assets/images/OnePunchimage/onepunch-game-over-image.png'),
    backgroundImage: require('../assets/images/OnePunchimage/onepunch-image-background.png'),
  },
  dragonBall: {
    backgroundMusic: '/audio/dragonball/gameover-music-dragonball.mp3',
    incorrectSound: '/audio/Bleach/bleach-incorrect-answer.mp3',
    gameOverSound: '/audio/dragonball/Dragon Ball OST - Milk Delivery.mp3',
    correctAnswerSound: '/audio/correct-ans.mp3',
    introImage: require('../assets/images/GamePageCovers/gamehom-dragonball.jpg'),
      gameOverBackground: require('../assets/dragonball-images/game-over-dragonball-image.png'),
    backgroundImage: require('../assets/dragonball-images/dragonball-background-imagee-pfthegame.webp'),
  },
};

export default animeConfig;
